import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Sidebar.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LogoImg from "../../assets/sonachandi.jpeg";

import { FaHome } from "@react-icons/all-files/fa/FaHome";
import { FaUsers } from "@react-icons/all-files/fa/FaUsers";
import { FaBoxOpen } from "@react-icons/all-files/fa/FaBoxOpen";
import { FaList } from "@react-icons/all-files/fa/FaList";
import { FaTags } from "@react-icons/all-files/fa/FaTags";
import { FaLayerGroup } from "@react-icons/all-files/fa/FaLayerGroup";
import { FaShieldAlt } from "@react-icons/all-files/fa/FaShieldAlt";
import { FaImage } from "@react-icons/all-files/fa/FaImage";
import { FaThLarge } from "@react-icons/all-files/fa/FaThLarge";
import { FaRulerCombined } from "@react-icons/all-files/fa/FaRulerCombined";
import { FaListAlt } from "@react-icons/all-files/fa/FaListAlt";
import { FaClipboardList } from "@react-icons/all-files/fa/FaClipboardList";
import { useNavigate } from "react-router-dom";
import { getAllMenus } from "../../services/menumaster/menu.service";
import { getAllowedMenus } from "../../services/menu_access/menu_access.service";

interface SidebarProps {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed }) => {
  const [menuData, setMenuData] = useState<any[]>([]);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [user, setUser] = useState<any | null>('');
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Icon Mapping
  const iconMap: any = {
    FaHome: <FaHome />,
    FaUsers: <FaUsers />,
    FaBoxOpen: <FaBoxOpen />,
    FaList: <FaList />,
    FaTags: <FaTags />,
    FaLayerGroup: <FaLayerGroup />,
    FaShieldAlt: <FaShieldAlt />,
    FaImage: <FaImage />,
    FaThLarge: <FaThLarge />,
    FaRulerCombined: <FaRulerCombined />,
    FaListAlt: <FaListAlt />,
    FaClipboardList: <FaClipboardList />,
  };

  // ✅ Fetch Menu API
 useEffect(() => {
  let getuser = localStorage.getItem('user');
  let parsedUser = getuser ? JSON.parse(getuser) : null;

  const roleId = parsedUser?.role_id;
  setUser(roleId);

  if (roleId) {
    fetchMenus(roleId); // ✅ direct pass
  }
}, []);

  const fetchMenus = async (roleId:any) => {

    // console.log(roleId);
    
    try {
      const res = await getAllowedMenus(roleId)

      const formattedMenus = res.data.map((menu: any) => ({
        name: menu.menu_name,
        path: menu.menu_route ? `${menu.menu_route}` : null,
        icon: iconMap[menu.menu_icon] || <FaHome />,

        submenu_master: menu.submenu_master?.map((sub: any) => ({
          name: sub.menu_name,
          path: sub.menu_route,
          icon: iconMap[sub.menu_icon] || <FaList />,
        })),
      }));

      // console.log("Menus:", formattedMenus); // debug

      setMenuData(formattedMenus);
    } catch (error) {
      console.error("Menu API Error:", error);
    }
  };

  const toggleMenu = (name: string) => {
    setOpenMenu(openMenu === name ? null : name);
  };

  const handleDirectLinkClick = () => {
    setOpenMenu(null);
  };

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* Header */}
     <div
  className="sidebar-header"
  onClick={() => navigate("/dashboard")}
  style={{ cursor: "pointer" }}
>
  {!collapsed ? (
    <>
      <img src={LogoImg} alt="Logo" className="sidebar-logo-img" />
      <span className="sidebar-logo-text">Sona Chandi</span>
    </>
  ) : (
    <span className="sidebar-logo-text sidebar-collapsed-text">SC</span>
  )}
</div>

      {/* Menu */}
      {menuData.map((menu) => {
        const isMenuOpen = openMenu === menu.name;

        const isActiveParent =
          menu.submenu?.some((sub: any) =>
            location.pathname.startsWith(sub.path)
          ) || location.pathname === menu.path;

        return (
          <div
            className={`menu-group ${isMenuOpen || isActiveParent ? "menu-active-group" : ""
              }`}
            key={menu.name}
          >
            {/* With submenu */}
            {menu.submenu_master && menu.submenu_master.length > 0 ? (
              <>
                <div
                  className={`menu-parent ${isMenuOpen ? "menu-parent-open" : ""
                    }`}
                  onClick={() => toggleMenu(menu.name)}
                >
                  <span className="icon">{menu.icon}</span>

                  {!collapsed && (
                    <>
                      <span className="menu-text">{menu.name}</span>
                      <span className="arrow">
                        {isMenuOpen ? (
                          <i className="fas fa-angle-down"></i>
                        ) : (
                          <i className="fas fa-angle-right"></i>
                        )}
                      </span>
                    </>
                  )}
                </div>

                {isMenuOpen && !collapsed && (
                  <div className="submenu submenu-open">
                    {menu.submenu_master.map((sub: any) => (
                      <NavLink
                        key={sub.name}
                        to={sub.path}
                        className={({ isActive }) =>
                          isActive ? "active-submenu" : ""
                        }
                      >
                        <span className="icon">{sub.icon}</span>
                        {sub.name}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // Without submenu
              <NavLink
                to={menu.path || "#"}
                onClick={handleDirectLinkClick}
                className={({ isActive }) =>
                  `menu-parent ${isActive ? "menu-parent-open" : ""}`
                }
              >
                <span className="icon">{menu.icon}</span>

                {!collapsed && (
                  <span className="menu-text">{menu.name}</span>
                )}

                {!collapsed && <span className="arrow-placeholder" />}
              </NavLink>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;